export default "__VITE_ASSET__DNn91SVf__"